export default {
  model: [
    {
      label: 'Nome',
      field: 'name',
      type: 'text'
    },
    {
      label: 'Email',
      field: 'email',
      type: 'email'
    },
    {
      label: 'Assunto',
      field: 'subject',
      type: 'text'
    },
    {
      label: 'Mensagem',
      field: 'message',
      type: 'text'
    }
  ]
}